import React from 'react';

import { withTranslation } from 'providers/GILT.provider';

class TableClientList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stateClientList: this.props.clientList,
      isNameAsc: false,
      isPhoneAsc: false,
      isEmailsAsc: false,
      isIDAsc: false,
    };
  }

  sortFunction = (tableRow) => {
    const sortList = [...this.state.stateClientList];
    if (tableRow === 'user_name') {
      if (this.state.isNameAsc) {
        sortList.sort((a, b) => (a.user_name > b.user_name ? -1 : 1));
      } else {
        sortList.sort((a, b) => (a.user_name < b.user_name ? -1 : 1));
      }
      this.setState({ isNameAsc: !this.state.isNameAsc });
    }
    if (tableRow === 'user__phone') {
      if (this.state.isPhoneAsc) {
        sortList.sort((a, b) => (a.user__phone > b.user__phone ? -1 : 1));
      } else {
        sortList.sort((a, b) => (a.user__phone < b.user__phone ? -1 : 1));
      }
      this.setState({ isPhoneAsc: !this.state.isPhoneAsc });
    }
    if (tableRow === 'user__email') {
      if (this.state.isEmailsAsc) {
        sortList.sort((a, b) => (a.user__email > b.user__email ? -1 : 1));
      } else {
        sortList.sort((a, b) => (a.user__email < b.user__email ? -1 : 1));
      }
      this.setState({ isEmailsAsc: !this.state.isEmailsAsc });
    }
    if (tableRow === 'id') {
      if (this.state.isIDAsc) {
        sortList.sort((a, b) => (a.id > b.id ? -1 : 1));
      } else {
        sortList.sort((a, b) => (a.id < b.id ? -1 : 1));
      }
      this.setState({ isIDAsc: !this.state.isIDAsc });
    }
    this.setState({ stateClientList: sortList });
  };

  render() {
    const { t } = this.props;

    return (
      <table className="tbl-client-duplicates">
        <thead>
          <tr>
            <th style={{ width: '172px' }} className="text-left">
              <span role="button" tabIndex={0} onClick={() => this.sortFunction('user_name')} className="sort-btn ">
                {t('exactDuplicateClients.tableHeaders.clientName')}
              </span>
            </th>
            <th style={{ width: '140px' }} className="text-left">
              <span role="button" tabIndex={0} onClick={() => this.sortFunction('user__phone')} className="sort-btn">
                {t('exactDuplicateClients.tableHeaders.mobileNumber')}
              </span>
            </th>
            <th style={{ width: '160px' }} className="text-left">
              <span role="button" tabIndex={0} onClick={() => this.sortFunction('user__email')} className="sort-btn">
                {t('exactDuplicateClients.tableHeaders.email')}
              </span>
            </th>
            <th style={{ width: '100px' }}>
              <span role="button" tabIndex={0} onClick={() => this.sortFunction('id')} className="sort-btn">
                {t('exactDuplicateClients.tableHeaders.clientId')}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {this.state.stateClientList.map((client) => (
            <tr key={this.state.stateClientList.indexOf(client)}>
              <td className="text-left text-cap">{client.user_name}</td>
              <td className="text-left">{client.user__phone}</td>
              <td>{client.user__email}</td>
              <td>{client.id}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

export default withTranslation()(TableClientList);
